import { ConnectorPlatform, Theme, type ExperienceSocialConnector } from '@logto/schemas';

export const isWeChatWebConnector = (connector: ExperienceSocialConnector) =>
  connector.target === 'wechat' && connector.platform === ConnectorPlatform.Web;

/** Same iframe parameters as WeChat's official WxLogin SDK; keep the server-issued state/callback. */
export const buildWeChatFrameUrl = (
  authorizationUri: string,
  theme: Theme = Theme.Dark,
  embedded = false
) => {
  const url = new URL(authorizationUri);
  if (url.origin !== 'https://open.weixin.qq.com' || url.pathname !== '/connect/qrconnect') {
    throw new Error('Unexpected WeChat authorization endpoint');
  }
  url.searchParams.set('login_type', 'jssdk');
  url.searchParams.set('self_redirect', embedded ? 'true' : 'false');
  url.searchParams.set('style', theme === Theme.Dark ? 'white' : 'black');
  url.searchParams.set('stylelite', '1');
  url.searchParams.set('color_scheme', theme === Theme.Dark ? 'dark' : 'light');
  return url.href;
};
